import React, { useState } from "react";
import Modal from '../../components/common/Modal';
import StaffsLeaveRequests from "./StaffsLeaveRequests";
import StudentsLeaveRequests from "./StudentsLeaveRequests";

const LeaveRequests = () => {

    const [leavTab, setLeaveTab] = useState("staffs");
    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="d-flex gap-2">
                        <button className={`btn ${leavTab === "staffs" ? " btn-primary" : "btn-outline-primary"} `} onClick={() => setLeaveTab("staffs")}>Staff Leave Requests</button>
                        <button className={`btn ${leavTab === "students" ? "btn-primary" : "btn-outline-primary "} `} onClick={() => setLeaveTab("students")}>Student Leave Requests</button>
                    </div>
                </div>
            </div>

            {leavTab === "staffs" && (
                <StaffsLeaveRequests />
            )}
            {leavTab === "students" && (
                <div>
                    <StudentsLeaveRequests />
                </div>
            )}
        </>
    )
}

export default LeaveRequests